import { useCallback } from 'react';

import Button from '@material-ui/core/Button';
import styled from 'styled-components';

import { Props as KpiTableProps } from '../../../../KpiTable';

const StyledButton = styled(Button)`
    width: 12px;
    min-width: 24px;
`;

const AddMonthButton = (props: Pick<KpiTableProps, 'canAddNewMonth' | 'addMonth'>) => {
    const { canAddNewMonth, addMonth } = props;

    const onClick = useCallback(() => {
        if (canAddNewMonth) addMonth();
    }, [canAddNewMonth, addMonth]);

    return (
        <StyledButton
            variant='contained'
            size='small'
            color='primary'
            disabled={!canAddNewMonth}
            onClick={onClick} >
            +
        </StyledButton>
    );
};

export default AddMonthButton;